import React, { FC } from "react";

import Audit from "./../../components/Audit";

const AuditLogPage: FC = () => <Audit />;

export default AuditLogPage;
